export function Icon({ name, size = 18, strokeWidth = 1.65, className = '' }) {
  const props = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    className,
    'aria-hidden': true,
  };
  const paths = {
    overview: <><path d="M3.5 10.5 12 3l8.5 7.5"/><path d="M5.5 9.2V21h13V9.2"/><path d="M9.5 21v-7h5v7"/></>,
    knowledge: <><path d="M4 5.5A3.5 3.5 0 0 1 7.5 2H12v18H7.5A3.5 3.5 0 0 0 4 23Z"/><path d="M20 5.5A3.5 3.5 0 0 0 16.5 2H12v18h4.5A3.5 3.5 0 0 1 20 23Z"/></>,
    timeline: <><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.4 2"/></>,
    history: <><path d="M4 6h16M7 3v6M17 3v6M5 10h14v10H5Z"/><path d="M8 14h3M8 17h7"/></>,
    spark: <path d="m12 3 1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8Z"/>,
    sources: <><path d="m12 2 8 4.5-8 4.5-8-4.5Z"/><path d="m4 11 8 4.5 8-4.5"/><path d="m4 15.5 8 4.5 8-4.5"/></>,
    skills: <><path d="m12 2.8 8 4.6v9.2l-8 4.6-8-4.6V7.4Z"/><path d="m4.2 7.5 7.8 4.4 7.8-4.4M12 12v9"/></>,
    graph: <><circle cx="5" cy="6" r="2"/><circle cx="18" cy="5" r="2"/><circle cx="12" cy="18" r="2"/><circle cx="14" cy="10" r="2"/><path d="m6.7 6.9 5.6 2.4M15.6 8.5l1.3-1.8M13.5 11.9l-1 4.2M6.5 7.5l4.4 8.8"/></>,
    fleet: <><rect x="3" y="4" width="18" height="6" rx="1"/><rect x="3" y="14" width="18" height="6" rx="1"/><path d="M7 7h.01M7 17h.01M11 7h6M11 17h6"/></>,
    search: <><circle cx="10.8" cy="10.8" r="6.8"/><path d="m16 16 5 5"/></>,
    close: <><path d="m5 5 14 14M19 5 5 19"/></>,
    chevron: <path d="m9 5 7 7-7 7"/>,
    back: <><path d="m15 5-7 7 7 7"/></>,
    document: <><path d="M6 2h8l4 4v16H6Z"/><path d="M14 2v5h5M9 12h6M9 16h6"/></>,
    pulse: <><path d="M2 12h4l2-7 4 14 3-9 2 2h5"/></>,
    filter: <><path d="M4 6h16M7 12h10M10 18h4"/><circle cx="9" cy="6" r="1.5" fill="currentColor" stroke="none"/><circle cx="15" cy="12" r="1.5" fill="currentColor" stroke="none"/><circle cx="12" cy="18" r="1.5" fill="currentColor" stroke="none"/></>,
    menu: <><path d="M4 6h16M4 12h16M4 18h16"/></>,
    arrow: <><path d="M4 12h15M14 7l5 5-5 5"/></>,
    check: <path d="m5 12 4 4L19 6"/>,
    info: <><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></>,
    command: <><path d="M9 6H6a3 3 0 1 0 3 3ZM15 6h3a3 3 0 1 1-3 3ZM9 18H6a3 3 0 1 1 3-3ZM15 18h3a3 3 0 1 0-3-3Z"/><path d="M9 6h6v12H9z"/></>,
    external: <><path d="M14 4h6v6M20 4l-9 9"/><path d="M18 13v7H4V6h7"/></>,
    hide: <><path d="M3 3l18 18M10.6 10.7a2 2 0 0 0 2.7 2.7"/><path d="M9.8 4.2A10 10 0 0 1 12 4c5.5 0 9 8 9 8a16 16 0 0 1-2.1 3.1M6.2 6.3C4.2 8 3 12 3 12s3.5 8 9 8a9 9 0 0 0 4-.9"/></>,
    trash: <><path d="M4 7h16M9 7V4h6v3M7 7l1 14h8l1-14M10 11v6M14 11v6"/></>,
    restore: <><path d="M4 8v5h5M5.6 16a7.5 7.5 0 1 0 .2-8.2L4 10"/></>,
    refresh: <><path d="M20 7v5h-5M4 17v-5h5"/><path d="M6.1 8.5A7 7 0 0 1 18.7 7M17.9 15.5A7 7 0 0 1 5.3 17"/></>,
    plus: <><path d="M12 5v14M5 12h14"/></>,
    minus: <path d="M5 12h14"/>,
    fit: <><path d="M8 3H3v5M16 3h5v5M21 16v5h-5M8 21H3v-5"/></>,
    play: <path d="m8 5 11 7-11 7Z" fill="currentColor" stroke="none"/>,
    pause: <><path d="M8 5v14M16 5v14" strokeWidth="2.4"/></>,
    restart: <><path d="M4 8V3M4 3h5"/><path d="M5.5 16.5A8 8 0 1 0 4 8"/></>,
  };
  return <svg {...props}>{paths[name] ?? paths.document}</svg>;
}

export function AtlasMark({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <circle cx="24" cy="24" r="19" stroke="currentColor" strokeWidth="1.25" opacity=".55" />
      <path d="M24 5 35 11.5 41 23 35 36 24 43 12 36 6 23 12 11.5Z" stroke="currentColor" strokeWidth="1.3" />
      <path d="m12 11.5 12 8L35 11.5M6 23l18-3.5L41 23M12 36l12-16.5L35 36M24 5v14.5M24 43V19.5" stroke="currentColor" strokeWidth="1" opacity=".8" />
      {[[24,5],[35,11.5],[41,23],[35,36],[24,43],[12,36],[6,23],[12,11.5],[24,19.5]].map(([cx,cy], i) => (
        <circle key={i} cx={cx} cy={cy} r={i === 8 ? 2.4 : 2} fill="#ff6b5d" stroke="#0b0e0f" strokeWidth=".8" />
      ))}
    </svg>
  );
}
